export const convertToFloat = (value: number | string) => {
  if (typeof value === "number") {
    return parseFloat(`${value}`);
  }
  return parseFloat(value);
};
